import React from 'react';
import PropTypes from 'prop-types';

const RadioButton = ({ option, onChange }) => {
  return (
    <div
      className="mx-4 gap-x-2 flex items-center cursor-pointer"
    >
      <input
        type="radio"
        id={option.id}
        name={option.name}
        value={option.name}
        checked={option.checked}
        onChange={() => onChange(option.id)}
        className="hidden"
      />
      <button
        className={`block w-6 h-6 bg-contain bg-no-repeat ${
          option.checked ? 'bg-radio-checked' : 'bg-radio-default'
        }`}
        onClick={() => onChange(option.id)}
        aria-label={option.name}
        type="button"
      />
      <label className="text-capitalize" htmlFor={option.id}>{option.name}</label><br />
    </div>
  );
};

RadioButton.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RadioButton;
